import api from './api';

/**
 * Login user
 * @param {string} email
 * @param {string} password
 * @returns {Promise} { user, token }
 */
export const login = async (email, password) => {
  try {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message || 'Erro ao fazer login. Verifique suas credenciais.';
    throw new Error(message);
  }
};

/**
 * Logout user
 * @returns {Promise}
 */
export const logout = async () => {
  try {
    await api.post('/auth/logout');
    return { success: true };
  } catch (error) {
    throw new Error('Erro ao fazer logout.');
  }
};

/**
 * Forgot password - sends reset link to email
 * @param {string} email
 * @returns {Promise}
 */
export const forgotPassword = async (email) => {
  try {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  } catch (error) {
    // Always show success to prevent email enumeration
    return {
      message: 'Se o email existir em nossa base, você receberá instruções para redefinir sua senha.',
    };
  }
};

/**
 * Reset password with token
 * @param {string} token
 * @param {string} email
 * @param {string} password
 * @param {string} passwordConfirmation
 * @returns {Promise}
 */
export const resetPassword = async (token, email, password, passwordConfirmation) => {
  try {
    const response = await api.post('/auth/reset-password', {
      token,
      email,
      password,
      password_confirmation: passwordConfirmation,
    });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Erro ao redefinir senha. O link pode ter expirado.';
    throw new Error(message);
  }
};

/**
 * Get current authenticated user
 * @returns {Promise} User data
 */
export const getCurrentUser = async () => {
  try {
    const response = await api.get('/auth/me');
    return response.data.data;
  } catch (error) {
    throw new Error('Erro ao buscar dados do usuário.');
  }
};

/**
 * Envia a foto do próprio usuário autenticado (qualquer perfil).
 * @param {File} file - A imagem a ser enviada
 * @returns {Promise<Object>} Usuário atualizado (formato da API)
 */
export const uploadOwnPhoto = async (file) => {
  try {
    const formData = new FormData();
    formData.append('photo', file);

    const response = await api.post('/auth/photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 30000,
    });
    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao enviar foto.');
  }
};
